import React from 'react';
import { Box, Typography, Link, LinkProps } from '@mui/material';

interface FeedLinkProps extends Omit<LinkProps, 'text'> {
  color?: string;
  backgroundColor?: string;
  href: string;
  text: React.ReactNode;
}

const FeedLink = ({
  color = 'inherit',
  backgroundColor = 'inherit',
  href,
  text,
  ...extra
}: FeedLinkProps) => {
  const linkSx = {
    color,
    backgroundColor,
    display: 'block',
    padding: '1rem 2rem 1.5rem 1rem',
    marginLeft: '-17px',
    marginRight: '-16px',
    marginTop: '12px',
    marginBottom: '0px',
    transition: 'all 0.3s',
    '@media (max-width: 540px)': {
      padding: '1rem 2rem 1.5rem 1rem'
    },
    '&:hover': {
      '> span': {
        paddingRight: '25px',
        '&:after': {
          opacity: 1,
          right: '-20px'
        }
      }
    }
  };

  const spanSx = {
    cursor: 'pointer',
    display: 'inline-block',
    position: 'relative',
    transition: '0.3s',
    paddingRight: '25px',
    '&:after': {
      content: '"→"',
      position: 'absolute',
      opacity: 1,
      top: 0,
      right: 0,
      transition: '0.3s'
    },
    fontSize: '17px',
    '@media (max-width: 540px)': {
      fontSize: '14px'
    }
  };

  return (
    <Box>
      <Link href={href} variant="subtitle1" sx={linkSx} {...extra}>
        <Typography variant="subtitle1" sx={spanSx} component="span">
          {text}
        </Typography>
      </Link>
    </Box>
  );
};

export default FeedLink;
